var PassengerType = /* @__PURE__ */ ((PassengerType2) => {
  PassengerType2["Adult"] = "Adult";
  PassengerType2["adult"] = "adult";
  PassengerType2["Child"] = "child";
  PassengerType2["Youth"] = "youth";
  PassengerType2["Senior"] = "senior";
  PassengerType2["Infant"] = "infant";
  return PassengerType2;
})(PassengerType || {});
var PassengerType_default = PassengerType;
export {
  PassengerType_default as default
};
